import * as React from "react";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { connect } from "react-redux";
import MyChartContainer from "../mychart/MyChartContainer";

class Questionnaires extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Questionnaires.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        const { serverData, epicId } = this.props; 
        return epicId
            ? <MyChartContainer mode="questionnairelist" title="Questionnaires" serverData={serverData} />
            : <MyChartContainer mode="questionnairelist" title="Questionnaires" needSectionError="true" serverData={serverData} />;
    }
}

const mapStateToProps = (state) => {
    return {
        serverData: state.session.serverData,
        epicId: state.domain.cu && state.domain.cu.eid ? state.domain.cu.eid : null
    };
};

const QuestionnairesWithData = connect(
    mapStateToProps
)(Questionnaires);

export default QuestionnairesWithData;